import {FC, useState} from 'react';
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Toolbar,
    Typography,
} from '@material-ui/core';

import {runInAction} from 'mobx';
import {observer} from 'mobx-react-lite';

import CloseIcon from '@material-ui/icons/Close';

import RootStore from '../../Core/mobx/RootStore';
import {AgentStore} from '../AgentStore';

import CustomerPortalPanel from './CustomerPortalPanel';

interface CustomerPortalSelectionDialogProps {
    store: AgentStore;
}

export const CustomerPortalSelectionDialog: FC<CustomerPortalSelectionDialogProps> = observer(({store}) => {
    const dialogOpen = store.customerPortalStore?.dialogOpen;
    const isCustomerSelectionChanged = store.customerPortalStore.isCustomerSelectionChanged;

    const [customerUnsavedAlert, setCustomerUnsavedAlert] = useState(false);

    function onCustomerAlertClose() {
        setCustomerUnsavedAlert(false);
    }

    function handleClose() {
        if (isCustomerSelectionChanged) {
            setCustomerUnsavedAlert(true);
            return;
        }

        runInAction(() => {
            store.customerPortalStore.dialogOpen = false;
        });
    }

    async function onSaveCustomerToAgent() {
        const contactsFormStore = RootStore.agentPortalStore.contactsFormStore;
        await contactsFormStore.saveForm();
        runInAction(() => {
            // Resetting the previous stored customer with the current saved one
            store.customerPortalStore.setSelectedCustomer(store.customerPortalStore.selectedCustomer);
            store.customerPortalStore.dialogOpen = false;
        });
    }

    function onCustomerAlertCloseByResettingSelection() {
        setCustomerUnsavedAlert(false);
        runInAction(() => {
            store.customerPortalStore.resetSelectedCustomer();
            store.customerPortalStore.dialogOpen = false;
        });
    }

    return (
        <Dialog fullScreen open={dialogOpen} onClose={handleClose}>
            <AppBar style={{position: 'relative'}}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" style={{marginLeft: 2, flex: 1}}>
                        Assign Customer
                    </Typography>
                    <Button
                        variant="text"
                        disabled={!isCustomerSelectionChanged}
                        color="inherit"
                        onClick={() => {
                            store.customerPortalStore.resetSelectedCustomer();
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        variant="text"
                        disabled={!isCustomerSelectionChanged}
                        autoFocus
                        color="inherit"
                        // eslint-disable-next-line react/jsx-no-bind
                        onClick={onSaveCustomerToAgent}
                    >
                        save
                    </Button>
                </Toolbar>
            </AppBar>
            <Grid container spacing={3}>
                <Grid item xs={12} style={{padding: 30}}>
                    <CustomerPortalPanel store={store} />
                </Grid>
            </Grid>
            <Dialog
                open={customerUnsavedAlert}
                onClose={onCustomerAlertClose}
                aria-labelledby="customer-unsaved-alert"
                aria-describedby="customer-unsaved-alert"
            >
                <DialogTitle>Unsaved Customer</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Do you want to continue without saving updated customer selection?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onCustomerAlertClose} color="primary" autoFocus>
                        Cancel
                    </Button>
                    <Button onClick={onCustomerAlertCloseByResettingSelection} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </Dialog>
    );
});

export default CustomerPortalSelectionDialog;
